import { ReducerCreators } from '@reduxjs/toolkit';

import { StylepacksState } from './types';
import GetStylepacks from '@/connection/greenroom/get-stylepacks';
import { FetchError } from '@/connection/helpers';
import { StyleCategories, StylepackCategoryMap, type Stylepack } from '@/types/stylepacks.types';

export const reducers = (create: ReducerCreators<StylepacksState>) => ({
  loadStylepacks: create.asyncThunk(
    async (_, { rejectWithValue }) => {
      try {
        return GetStylepacks();
      } catch (e) {
        if (e instanceof FetchError) {
          throw rejectWithValue(e.body);
        }

        throw rejectWithValue({ error: e });
      }
    },
    {
      fulfilled: (state, action) => {
        const packs = action.payload;

        const stylepacks = Object.values(
          packs.templates.reduce<Record<string, Stylepack>>((acc, pack) => {
            // packs request contains hundreds of rows with data not relevant to this app
            // see network response for full response body
            if (pack.provider !== 'capsule') {
              return acc;
            }

            // group rows by which stylepack they belong to
            if (acc[pack.stylePack]) {
              acc[pack.stylePack].videos.push(pack);
            } else {
              acc[pack.stylePack] = {
                stylePack: pack.stylePack,
                themeId: pack.themeId ?? null,
                name: pack.name,
                videos: [pack],
                categories: StylepackCategoryMap[pack.stylePack] || [StyleCategories.classic],
              };
            }

            return acc;
          }, {})
        );

        state.stylepacks = stylepacks;
        state.errorLoadingStylepacks = false;
        state.stylepackContent = action.payload.templates;
      },
      pending: (state) => {
        state.loadingStylepacks = true;
      },
      rejected: (state, action) => {
        console.error(action.payload);
        state.errorLoadingStylepacks = true;
      },
      settled: (state) => {
        state.loadingStylepacks = false;
      },
    }
  ),
});
